module.exports = __webpack_public_path__ + "static/media/pp-homeTablet3.c56cb840.png";